import HelpArticleCategoryEdit from "../Views/HelpArticleCategory/HelpArticleCategoryEdit.vue";
import HelpArticleCategoryCreate from "../Views/HelpArticleCategory/HelpArticleCategoryCreate.vue";
import HelpArticleCategoryList from "../Views/HelpArticleCategory/HelpArticleCategoryList.vue";
import {MODULES} from "../Constants/modules.js";

export const helpArticleCategoryRoutes = [
    {
        path: "/help-article-categories/edit/:id",
        name: "help-article-categories.edit",
        component: HelpArticleCategoryEdit,
        meta: {
                module: MODULES.HELP_CENTER,
            menu: {
                parent: 'help-articles',
                child: 'help-article-categories'
            },
            breadcrumb: {
                title: "Catégories du centre d'aide",
                nav: {
                    all: {
                        active: "Modification",
                        inactive: [{
                            title: "Toutes les catégories",
                            link: {name: 'help-article-categories.list'}
                        }]
                    }
                }
            }
        },
    },
    {
        path: "/help-article-categories/create",
        name: "help-article-categories.create",
        component: HelpArticleCategoryCreate,
        meta: {
                module: MODULES.HELP_CENTER,
            menu: {
                parent: 'help-articles',
                child: 'help-article-categories'
            },
            breadcrumb: {
                title: "Catégories du centre d'aide",
                nav: {
                    all: {
                        active: "Création",
                        inactive: [{
                            title: "Toutes les catégories",
                            link: {name: 'help-article-categories.list'}
                        }]
                    }
                }
            }
        },
    },
    {
        path: "/help-article-categories",
        name: "help-article-categories.list",
        component: HelpArticleCategoryList,
        meta: {
                module: MODULES.HELP_CENTER,
            menu: {
                parent: 'help-articles',
                child: 'help-article-categories'
            },
            breadcrumb: {
                title: "Catégories du centre d'aide",
                nav: {
                    all: {
                        active: "Toutes les catégories",
                        inactive: []
                    }
                }
            }
        },
    }
];
